import { createOrEditActivityType } from '../../../actions/areas/admin/commandActions';
import globals from '../../../globals/communityGlobals';

const locale = globals.getAreas(['activityTypes', 'error']);

export const eventHandlers = (state, setState, auth) => {
  const refreshTable = () => setState(newState => ({ ...newState, forceReload: !state.forceReload }));
  const handleSidePanel = (isOpen, type) => {
    const typeId = type ? type[0] : null;
    const activityTypeName = type ? type[1] : '';
    setState(newState => ({ ...newState, openSideActivityTypePanel: isOpen, typeId, activityTypeName }));
  };

  return {
    locale,
    addButtonText: locale.getMsg('addButtonText'),
    refreshTable,
    handleSidePanel,
    createOrEditActivityType: model => {
      handleSidePanel(false);
      createOrEditActivityType(auth, model, refreshTable);
    },
  };
};
